import { SpaceType } from "../../../data";

interface SubscriptionOfferingSpace {
  id: string;
  locationId: string;
  name: string;
  imgUrl: string;
}

export interface SubscriptionOffering {
  name: string;
  freeUnits: number | null;
  usedUnits: number;
  spaceType: SpaceType;
  spaces: SubscriptionOfferingSpace[];
}

export function toSubscriptionOfferings(data: any): SubscriptionOffering {
  return {
    name: data?.space_type === "entire_location" ? "Day Pass" : "",
    freeUnits: data?.free_units,
    usedUnits: data?.used_units,
    spaceType: data?.space_type,
    spaces: data?.spaces?.map((s: any) => ({
      id: s.id,
      locationId: s.location_id,
      name: s.name,
      imgUrl: s.image?.url,
    })),
  };
}
